function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Iconly/Bulk/Image 3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Image 2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill 1",
  d: "M21.9999 14.7021V16.0856C21.9999 16.3152 21.9899 16.5468 21.9699 16.7764C21.6893 19.9355 19.4949 21.9998 16.3286 21.9998H7.67126C6.06806 21.9998 4.71535 21.4794 3.74341 20.536C3.36265 20.1861 3.042 19.7751 2.7915 19.3039C3.12217 18.9018 3.49291 18.4617 3.85363 18.0206C4.46485 17.2887 5.05603 16.5659 5.42677 16.0957C5.97788 15.4139 7.43078 13.6193 9.44481 14.4615C9.85563 14.6319 10.2164 14.8726 10.547 15.0831C11.3586 15.6245 11.6993 15.7849 12.2705 15.4741C12.9017 15.1332 13.3125 14.4615 13.7434 13.7597C13.9739 13.3878 14.2043 13.0278 14.4548 12.697C15.547 11.2734 17.2304 10.8924 18.6332 11.7345C19.3346 12.1556 19.9358 12.687 20.4969 13.2273C20.6172 13.3477 20.7374 13.4589 20.8476 13.5692C20.9979 13.7196 21.4989 14.2209 21.9999 14.7021Z",
  fill: "#8B8B8B"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill 3",
  opacity: 0.4,
  d: "M16.3387 2H7.67134C4.27455 2 2 4.37607 2 7.91411V16.086C2 17.3181 2.28056 18.4119 2.79158 19.3042C3.12224 18.9022 3.49299 18.4621 3.85371 18.0199C4.46493 17.2891 5.05611 16.5662 5.42685 16.096C5.97796 15.4143 7.43086 13.6197 9.44489 14.4618C9.85571 14.6323 10.2164 14.8729 10.5471 15.0834C11.3587 15.6248 11.6994 15.7852 12.2705 15.4734C12.9018 15.1336 13.3126 14.4618 13.7435 13.759C13.9739 13.3881 14.2044 13.0282 14.4549 12.6973C15.5471 11.2737 17.2305 10.8927 18.6333 11.7349C19.3347 12.1559 19.9359 12.6873 20.497 13.2277C20.6172 13.348 20.7375 13.4593 20.8477 13.5696C20.998 13.7189 21.499 14.2202 22 14.7025V7.91411C22 4.37607 19.7255 2 16.3387 2Z",
  fill: "#8B8B8B"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill 5",
  d: "M11.4543 8.79644C11.4543 10.205 10.2809 11.378 8.87313 11.378C7.46632 11.378 6.29297 10.205 6.29297 8.79644C6.29297 7.38884 7.46632 6.21484 8.87313 6.21484C10.2809 6.21484 11.4543 7.38884 11.4543 8.79644Z",
  fill: "#8B8B8B"
})));
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.89e1523e.svg";
export { ForwardRef as ReactComponent };